module.exports = __webpack_public_path__ + "static/media/maintainance.89cdacdb.svg";